import { lazy, Suspense } from 'react';

import type { ImageCropModalProps } from './types';

function loadImageCropModal() {
  return import('./image-crop-modal').then((module) => ({
    default: module.ImageCropModal,
  }));
}

const LazyImageCropModal = lazy(loadImageCropModal);

export function ImageCropModal(props: ImageCropModalProps) {
  return (
    <Suspense fallback={null}>
      <LazyImageCropModal {...props} />
    </Suspense>
  );
}
